// extracted by mini-css-extract-plugin
module.exports = {"registerBackground":"Register_registerBackground__2MFh4","card":"Register_card__2-gK4"};